import React from 'react';
import { SvgIcon } from '@mui/material';

export function CheckMarkInCircleIcon(props) {
  return (
    <SvgIcon
      sx={{ width: '24px', height: '24px', viewBox: '0 0 24px 24px' }}
      {...props}
      viewBox="0 0 24 24"
      fill="none"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#29EDFF" />
        <path
          d="M6.75 12.2059L9.92297 15.5025L16.9035 8.25"
          stroke="#4520AB"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </SvgIcon>
  );
}
